/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { HtmlParser } from 'sarsaparilla';

const propTypes = {
    permit: PropTypes.shape({
        description: PropTypes.shape({
            fee_policy: PropTypes.string,
            cancellation_policy: PropTypes.string,
        }),
    }),
};

export default class Fees extends React.Component {
    render() {
        const { fee_policy: feePolicy } = this.props.permit.description;

        return (
            <div>
                <HtmlParser html={feePolicy} />
            </div>
        );
    }
}

Fees.propTypes = propTypes;
